module.exports = __webpack_public_path__ + "img/metamask1.f329f2c0.png";